import * as React from 'react';
import { Box, ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

/**
 * Props for the MoveFromSection component
 * @interface MoveFromSectionProps
 * @property {string} moveFrom - The current location of the items being moved
 */
export interface MoveFromSectionProps {
  moveFrom: string;
}

/**
 * A section component that displays the "Move From" section of the modal.
 * Shows the current location of the items being moved.
 *
 * @component
 * @example
 * ```tsx
 * <MoveFromSection
 *   moveFrom="Content → Pages → 1.1 → Components"
 * />
 * ```
 */
export const MoveFromSection: React.FC<MoveFromSectionProps> = ({
  moveFrom,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <ParagraphText css={{ fontWeight: '$bold', fontSize: '$bodyTwo' }}>
        {formatMessage({
          id: 'MOVE_FROM_LABEL',
        })}
      </ParagraphText>
      <ParagraphText
        css={{
          marginInlineStart: '$four',
          marginBlockStart: '$threeQuarters',
          fontSize: '$bodyTwo',
        }}
      >
        {moveFrom}
      </ParagraphText>
    </Box>
  );
};
